module.exports = __webpack_public_path__ + "static/media/bar.7a31e19e.svg";